import React from "react";

export const SocketContext = React.createContext({
    socket: null,
});




export const TYPE_UPDATE_MESSAGE = "visit_update_message";
export const TYPE_CREATE_MESSAGE = "visit_create_message";
export const TYPE_REPORT_GENERATE = "visit_report_generate";
export const TYPE_REPORT_EMPLOYEE_GENERATE = "employee_report_generate";
